export const ACTIVE_CONVERSATION_WITH_RETAILER_KEY = 'activeConversationWithRetailer';
export const CHAT_TEXT_STORAGE_KEY = 'conversationActive';
export const DEALS_APP_STATE_STORAGE_KEY = 'at.dealsApp.state';
export const DEALS_STATE_CURRENT_KEY = 'at.dealsApp.current';
export const LAST_VIEWED_ADVERT_ID = 'lastViewedAdvertId'; // the last advert id the user interacted with
export const SAVED_ADVERTS = 'savedAdverts';
export const SEARCH_URL_STORAGE_KEY = 'searchUrl'; // the last url the user searched for
export const USER_LOCATION_LATITUDE_STORAGE_KEY = 'userlocation.latitude';
export const USER_LOCATION_LONGITUDE_STORAGE_KEY = 'userlocation.longitude';
export const USER_LOCATION_POSTCODE_STORAGE_KEY = 'userlocation.postcode';
export const DEALS_ADVERTS_KEY = 'dealsAdvertData';
